/**
 * Lightweight client-side logger for metadata-only events (no user draft
 * content, no reflection text). Forwards to console in development and is a
 * no-op in production builds — swap for a real analytics sink later.
 */

type Metadata = Record<string, string | number | boolean | null | undefined>;

function shouldEmit(): boolean {
  return typeof import.meta !== "undefined" && import.meta.env?.DEV === true;
}

export const logger = {
  info(event: string, meta?: Metadata): void {
    if (!shouldEmit()) return;
    // eslint-disable-next-line no-console
    console.info(`[${event}]`, meta ?? {});
  },
  warn(event: string, meta?: Metadata): void {
    if (!shouldEmit()) return;
    // eslint-disable-next-line no-console
    console.warn(`[${event}]`, meta ?? {});
  },
};
